const AboutUs = () => {
  return (
    <div>
      <div>
        <h1>About Sri Dhanvantari Exports</h1>
        <div className="section-content">
          <p>
            Established in the year 2020, Sri Dhanvantari Exports has become one of the most prominent and leading suppliers of Food Starch Products all over India. In a short span of time, we have become renowned for very high client satisfaction. Our products score high in terms of quality but are cost-effective at the same time. The aroma, freshness, nutritional content and taste of our products are unbeatable. We believe in building international standards for innovation and providing quality in products & services we deliver to our clients.
          </p>
        </div>
      </div>

      <div>
        <h2 className="title text-animation">Our Vision</h2>
        <div className="section-content">
          <p>
            To Build a Robust world class company for sustainable global trade and to improve lives of all parties involved in international business cycle.
          </p>
        </div>
      </div>

      <div >
        <h2 className="title text-animation">Our Mission</h2>
        <div className="section-content">
          <p>
           Aims to Bring maximum value to customers for the price they pay us to all our Retail, Wholesale and Global Customers.</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;